export default "__VITE_ASSET__Ddy19aS6__"